import { CheckOutlined, CloseOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons"
import {Modal, Form, Input, Radio, Space, Button, Select, Spin} from "antd"
import axios from "axios"
import { useEffect, useRef, useState } from "react"

const backend = process.env.REACT_APP_BACKEND;

export default function EditGroupModal ({pageRef, stateHandler, editModal, data}) {
  const ref = useRef()
  const [loading, setLoading] = useState(false)
  const [curTitle, setCurTitle] = useState(data.title)

  //초기화 버튼 함수
  const clearHandler = () => {
    ref.current.resetFields()
    setCurTitle(data.title)
  }

  //pre버튼 클릭 시 함수
  const preRecordHandler = () => {
    stateHandler("rowIndex-", data.indexNumber)
  }

  //next버튼 클릭 시 함수
  const nextRecordHandler = () => {
    stateHandler("rowIndex+", data.indexNumber)
  }

  //단어 수정 함수
  const editHandler = async () => {
    try {
      setLoading(true)
      await ref.current.validateFields()
      const value = await ref.current.getFieldsValue()

      axios.patch(`${backend}/contents/word_dictionary/group/list/${value.code}`,{value})
        .then(res => {
          Modal.success({
            title: "수정 완료",
            content: "정상적으로 수정 되었습니다.",
            okText: "확인",
            onOk: ()=>stateHandler("editModal", false)
          })
          stateHandler("reRender")
        })
        .catch(err => {
          console.log(err)
          setLoading(false)
        })
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  //취소 버튼 함수
  const cancelHandler = () => {
    stateHandler("editModal", false)
  }

  useEffect(()=>{
    if(!pageRef.current) {
      ref.current.resetFields()
      setCurTitle(data.title)
    }
  },[data])

  return (
    <Modal 
    open={editModal}
    destroyOnClose = {true}
    title = "그룹 수정"
    onCancel={cancelHandler}
    maskClosable = {false}
    footer = {
      <Spin spinning={loading} indicator={null}>
        <Space style={{width:"100%", justifyContent:"space-between"}}>
          <Button onClick={clearHandler}>내용 초기화</Button>
          <Space>
            <Button onClick={preRecordHandler}><LeftOutlined/>이전</Button>
            <Button type="primary" disabled={curTitle === data.title} onClick={editHandler}><CheckOutlined/>수정</Button>
            <Button onClick={nextRecordHandler}><RightOutlined/>다음</Button>
            <Button onClick={cancelHandler}><CloseOutlined/>취소</Button>
          </Space>
        </Space>
      </Spin>
    }
      >
          <Spin spinning={loading}>
        <Form 
          layout="vertical" 
          ref={ref} 
          initialValues={
            {
              code: data?.code, 
              SystemSettingLanguage_code:"L0010",
              title: data?.title
            }
          }>
          <Form.Item
            name="code"
            label="그룹 코드"
            rules={[
              {required: true, message:"필수 입력값입니다."},
              {
                pattern: /^WG\d{4}$/,
                message: '그룹코드는 "WG"와 네자리숫자 형식이어야 합니다.',
              },
            ]}
          >
            <Input disabled></Input>
          </Form.Item>

          <Form.Item
            name="SystemSettingLanguage_code"
            label="언어"
            hidden
          >
            <Input></Input>
          </Form.Item>

          <Form.Item
            name="title"
            label="그룹 제목(한국어)"
            rules={[
              {required: true, message:"필수 입력값입니다."}
            ]}
          >
            <Input onChange={(e)=>{setCurTitle(e.target.value)}}></Input>
          </Form.Item>
          
        </Form>
      </Spin>
    </Modal>
  )
}